import { createStore, applyMiddleware, combineReducers, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { all } from 'redux-saga/effects'

/* IMPORT CONTAINER STATES
 --------------------------------------------------------------- */
import { appReducers, appSagas } from 'connectors/app/app.state'
import {
  snowplowReducers,
  snowplowSagas
} from 'connectors/snowplow/snowplow.state'
import { userReducers, userSagas } from 'connectors/user/user.state'

import { featureReducers } from 'connectors/feature-flags/feature-flags.state'
import { featureSagas } from 'connectors/feature-flags/feature-flags.state'

import { exploreReducers } from 'containers/explore/explore.state'
import { exploreSagas } from 'containers/explore/explore.state'

import { topicListReducers } from 'connectors/topic-list/topic-list.state'
import { topicListSagas } from 'connectors/topic-list/topic-list.state'

import { topicReducers } from 'containers/topic/topic.state'
import { topicSagas } from 'containers/topic/topic.state'

import { pocketHitsReducers } from 'connectors/pocket-hits/pocket-hits.state'
import { pocketHitsSagas } from 'connectors/pocket-hits/pocket-hits.state'

import { syndicatedArticleReducers } from 'containers/syndicated-article/syndicated-article.state'
import { syndicatedArticleSagas } from 'containers/syndicated-article/syndicated-article.state'

import { itemsReducers } from 'connectors/items/items.state'
import { itemsSagas } from 'connectors/items/items.state'

import { recitReducers } from 'connectors/recit/recit.state'
import { recitSagas } from 'connectors/recit/recit.state'

import { variantReducers } from 'connectors/variant-flags/variant-flags.state'
import { variantSagas } from 'connectors/variant-flags/variant-flags.state'

/* REDUCERS
 --------------------------------------------------------------- */
const pageReducers = {
  explore: exploreReducers,
  topic: topicReducers,
  pocketHits: pocketHitsReducers,
  syndicatedArticle: syndicatedArticleReducers
}

const connectorReducers = {
  app: appReducers, // App wide (mostly example at this time)
  features: featureReducers, // Feature flags (very basic start)
  topicList: topicListReducers, // Valid topics list and active topic
  user: userReducers, // User profile and auth
  items: itemsReducers, // Shared item store for all items in app
  recit: recitReducers, // Recommended articles, both publisher and pocket
  variants: variantReducers, // Variant flags (basic and temporary)
  snowplow: snowplowReducers // Snowplow analytics config post-initial-load
}

const rootReducer = combineReducers({
  ...pageReducers,
  ...connectorReducers
})

/* SAGAS
 --------------------------------------------------------------- */
function* rootSaga() {
  yield all([
    ...appSagas,
    ...featureSagas,
    ...userSagas,
    ...itemsSagas,
    ...exploreSagas,
    ...topicListSagas,
    ...topicSagas,
    ...pocketHitsSagas,
    ...syndicatedArticleSagas,
    ...recitSagas,
    ...variantSagas,
    ...snowplowSagas
  ])
}

/* STORE
 --------------------------------------------------------------- */
export const initializeStore = (initialState, { isServer, req = null }) => {
  const sagaMiddleware = createSagaMiddleware()

  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ name: 'Pocket Discover' })
      : compose

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(sagaMiddleware))
  )

  if (req || !isServer) {
    store.sagaTask = sagaMiddleware.run(rootSaga)
  }

  return store
}

export default initializeStore
